export default __webpack_public_path__ + "static/media/sendSms.8a7bca2b.svg";